export var inline = false;
export function inlineMock(nextInline) {
  if (typeof nextInline === 'boolean') {
    inline = nextInline;
  }

  return inline;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/portal/es/mock.js
// module id = 1197
// module chunks = 0